// extracted by mini-css-extract-plugin
export default {"sidebarContainer":"SocialLayout_sidebarContainer__qhoiF","miniProfileCardWrapper":"SocialLayout_miniProfileCardWrapper__LKRci"};